/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import axios from 'axios';
import { sha256 } from 'js-sha256';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { FaPlay } from 'react-icons/fa';
import { Md360 } from "react-icons/md";
import { sendUser } from '../../../../../../services/properties';
import { trackEvent } from '../../../../../../utils/FunctionsGlobals';
// utils
import { AppPhoneInput } from '../../../../../../components/input_phone/AppPhoneInput';
import { getWatermarkImageSrc, WatermarkFallbackImage } from '../WatermarkFallbackImage';
import styles from './GalleryPiecesProperties.module.css';

const GalleryPiecesProperties: React.FC<{

    gallery: Array<any>;
    site: any;
    detailsProperties: any;
    setZoomPhoto: any;
    orderGallery: any;
    setOrderGallery: any;
    origin?: any;
    codsite?: any;
}> = ({
    gallery,
    site,
    detailsProperties,
    setZoomPhoto,
    orderGallery,
    setOrderGallery,
    origin,
    codsite,
}) => {
    // useState
    const router = useRouter();
    const { utm_campaign } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const { verFts } = router.query;
    const { verfts } = router.query;
    const { agenciador } = router.query;
    const [animationPhoto, setAnimationPhoto] = useState<number>(-1);
    const [name, setName] = useState('');
    const [telephone, setTelephone] = useState('');
    const [email, setEmail] = useState('');
    const [existUser, setExistUser] = useState<any>(null);
    const [acceptPolitic, setAcceptPolitic] = useState(false);
    const [processando, setProcessando] = useState(false);
    const [interesse, setInteresse] = useState<any>(site?.transacoes[0]);
    const isSite2504 = Number(site?.id) === 2504;
    const propertyTitle = String(detailsProperties?.titulo || '').trim();
    const hasPropertyTitle = propertyTitle.length > 0 && propertyTitle.toLowerCase() !== 'null';
    // const [active, setActive] = useState(false);

    const selectTransacao = async () => {
        if(interesse == "Venda"){
            setInteresse("Aluguel")
        } else {
            setInteresse("Venda")
        }
    }

    useEffect(() => {
        try {
            const getUser: any = localStorage.getItem('user');
            setExistUser(JSON.parse(getUser || ''));
        } catch (error) {}
    }, []);

    const buildMediaGallery = (photos: any[], includeBlocked = false) => {
        const items = [...photos];
        const hasVideo =
            detailsProperties?.link_video &&
            ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' &&
                detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") ||
                site?.id != '2059');
        const hasTour = Boolean(detailsProperties?.tour360);

        if (hasVideo && hasTour) {
            const video = detailsProperties?.link_video
                .replaceAll("https://www.youtube.com/watch?v=","")
                .replace("https://youtu.be/","")
                .split("&");

            if (isSite2504) {
                items.push(
                    { id: 'video', video: video[0]?.split('/')?.slice(-1)[0] },
                    { id: 'tour360', video: detailsProperties?.tour360 }
                );
            } else {
                items.unshift(
                    { id: 'video', video: video[0]?.split('/')?.slice(-1)[0] },
                    { id: 'tour360', video: detailsProperties?.tour360 }
                );
            }
        } else if (hasVideo) {
            const video = detailsProperties?.link_video
                .replaceAll("https://www.youtube.com/watch?v=","")
                .replace("https://youtu.be/","")
                .split("&");

            if (isSite2504) {
                items.push({ id: 'video', video: video[0]?.split('/')?.slice(-1)[0] });
            } else {
                items.unshift({ id: 'video', video: video[0]?.split('/')?.slice(-1)[0] });
            }
        } else if (hasTour) {
            if (isSite2504) {
                items.push({ id: 'tour360', video: detailsProperties?.tour360 });
            } else {
                items.unshift({ id: 'tour360', video: detailsProperties?.tour360 });
            }
        }

        if (includeBlocked) {
            items.push({ id: 'bloquear' });
        }

        return items;
    };

    useEffect(() => {
        if (gallery?.length > 0 && site?.id && detailsProperties?.id) {
            const validationOrderGallery = gallery
            const validationGallery =
                existUser || verFts === "1" || verfts == '1' ||
                (detailsProperties?.aluguel > 0
                        ? Number(site?.libera_fts_aluguel)
                        : (!Number(site?.bloquear_fotos) && !detailsProperties?.bloquear_fotos))
                    ? validationOrderGallery
                    : validationOrderGallery?.slice(
                          0,
                          site?.qtd_fotos_bloqueios
                      );
            if (
                existUser || verFts === "1" || verfts === '1' ||
                (detailsProperties?.aluguel > 0
                        ? Number(site?.libera_fts_aluguel)
                        : (!Number(site?.bloquear_fotos) && (!Number(detailsProperties?.bloquear_fotos == true))))
            ) {
                setOrderGallery(buildMediaGallery(validationGallery));
            } else {
                setOrderGallery(buildMediaGallery(validationGallery, true));
            }
        }
    }, [gallery, site, detailsProperties, existUser]);

    // methods
    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setName(value);
    };

    // const openForm = () => {
    //     setActive(true);
    // };

    const onChangeTelephone = (value: string) => {
        setTelephone(value);
    };
    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
    }

    const validaSendUser = async () => {
        if (name != '' && email != '' && telephone != '') {
            const phone = telephone.replace(/[^0-9]/g, '');
            const valida = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 17 && (site?.internacional || phone.length < 12) && valida) {
                if (re.test(email) == true) {
                    if(acceptPolitic && !processando){
                        if(!processando){
                            setProcessando(true);
                            actionSendUser();
                        }
                    }else {
                        alert('Concorde com os termos de uso!');
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para ver mais fotos!'
            );
        }
    };
    const actionSendUser = async () => {
        const getSendUser = await sendUser(
            site?.internacional ? true : false,
            JSON.stringify(utm_campaign),
            JSON.stringify(utm_source),
            JSON.stringify(utm_medium),
            JSON.stringify(utm_id),
            JSON.stringify("Solicitou ver mais fotos do imóvel " + detailsProperties?.id),
            JSON.stringify(name),
            JSON.stringify(email),
            JSON.stringify(telephone),
            detailsProperties?.id,
            agenciador != undefined ? Number(agenciador) : 0,
            origin,
            codsite,
            interesse ? interesse : ""
        );
        localStorage.setItem(
            'user',
            JSON.stringify({
                name,
                email,
                telephone,
                id_client: getSendUser?.atendimento?.id_cliente,
            })
        );
        const user = {
            name,
            telephone,
            email,
        };
        localStorage.setItem('user', JSON.stringify(user));
        window.location.reload();
        if(!router.asPath.includes("enviar=1")){
            if(router.asPath.includes("?")) {
                window.location.replace(router.asPath+ "&enviar=1");
            }else {
                window.location.replace(router.asPath+ "?enviar=1");
            }
        }
        setProcessando(false);

        if (site?.tag_google_head || site?.google_analytics_head) {
            // NÃO mande PII para GA/GTM:
            const gaParams = {
            source: "property",
            property_ref: detailsProperties?.referencia,
            property_id: detailsProperties?.id,
            listing_type: detailsProperties?.venda ? "venda" : (detailsProperties?.aluguel ? "aluguel" : "na"),
            city: detailsProperties?.cidade?.nome,
            neighborhood: detailsProperties?.bairro?.nome,
            price: detailsProperties?.preco ?? detailsProperties?.preco_loca ?? 0,
            currency: "BRL",
            // opcional: padronize com items[] (melhora análises)
            items: [{
                item_id: String(detailsProperties?.referencia ?? detailsProperties?.id),
                item_name: detailsProperties?.tipo?.nome ?? "Imóvel",
                item_category: "Imóveis",
                item_variant: detailsProperties?.bairro?.nome,
                price: detailsProperties?.preco ?? detailsProperties?.preco_loca ?? 0,
                currency: "BRL",
                item_brand: site?.Dados?.empresa,
                item_list_name: "property_page",
            }],
            };

            // Dispara para GTM/GA4
            trackEvent("generate_lead", gaParams);
            trackEvent("lead_submit_success", gaParams);
        }

        const getCookie = (name: string) =>
            document.cookie
            .split('; ')
            .find((row) => row.startsWith(name + '='))
        ?.split('=')[1] || ''

        if (site?.fb_token_pixel && site?.fb_id_pixel && getSendUser?.atendimento?.id_cliente) {
            const accessToken = site?.fb_token_pixel;
            const pixelId = site?.fb_id_pixel;
            const currentTimestampInSeconds = Math.floor(Date.now() / 1000);

            // Normalização dos dados
            const normalizedName = name.trim().toLowerCase();
            const normalizedEmail = email.trim().toLowerCase();
            const normalizedPhone = telephone.replace(/\D/g, ''); // Apenas números

            // Hash dos dados
            const hashNome = sha256(normalizedName);
            const hashEmail = sha256(normalizedEmail);
            const hashTelefone = sha256(normalizedPhone);

            const fbc = getCookie('_fbc')
            const fbp = getCookie('_fbp')

            let clientIpAddress: string
            try {
                const res6 = await axios.get<{ ip: string }>(
                'https://api6.ipify.org?format=json'
                )
                clientIpAddress = res6.data.ip
            } catch {
                const res4 = await axios.get<{ ip: string }>(
                'https://api.ipify.org?format=json'
                )
                clientIpAddress = res4.data.ip
            }

            // Dados do evento
            const eventData = [
                {
                event_name: 'Lead',
                event_time: currentTimestampInSeconds,
                action_source: 'website',
                event_source_url: 'https://' + site?.site,
                user_data: {
                    fn: [hashNome],
                    em: [hashEmail],
                    ph: [hashTelefone],
                    fbc: fbc || undefined,
                    fbp: fbp || undefined,
                    client_ip_address: clientIpAddress
                }
            }];

            axios.post(
                `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`,
                { data: eventData }
            )
                .then(response => {
                console.log('Evento registrado com sucesso:', response.data);
                })
                .catch(error => {
                console.error('Erro ao registrar evento:', error?.response?.data || error.message);
            });
        }
    };

    return (
        <div className={styles.container}>
            {orderGallery?.map((v: any, i: number) => {
                const photoSrc = getWatermarkImageSrc(v?.url_foto, site);
                const photoRetrySrc = getWatermarkImageSrc(v?.url_foto_menor, site);
                const photoIndex = orderGallery.slice(0, i + 1).filter((item: any) => item?.url_foto).length - 1;
                const isPriorityPhoto = photoIndex >= 0 && photoIndex < 2;
                const activeAnimationPhoto = () => {
                    setAnimationPhoto(Number(v?.id));
                };
                const openPhoto = () => {
                    setZoomPhoto(i);
                };
                if (
                    !existUser &&
                    v?.id === 'bloquear' && verFts != "1" && verfts != '1' && ((site?.bloquear_fotos || detailsProperties?.bloquear_fotos) || (detailsProperties?.aluguel && site?.libera_fts_aluguel == 0 ? true : false))
                )  {
                    return (
                        <div
                            className={styles.container_form}
                            key={'block'+v?.id}
                            // onMouseEnter={openForm}
                        >
                            {/* {active ? ( */}
                            <div className={styles.form}>
                                {site?.id == 1630 ? 
                                    <label className={styles.title}>
                                        Ver mais fotos
                                    </label>
                                :
                                    <>
                                    <label className={styles.title}>
                                        Acesso completo
                                    </label>
                                    <div className={styles.subtitle}>
                                        <p
                                            className={styles.subtitle_time}
                                            style={{ color: "#c5c5c5" }}
                                        >
                                            a todo o site em 10 segundos!
                                        </p>
                                    </div>
                                    </>
                                }
                                <input
                                    className={styles.input}
                                    placeholder="Nome"
                                    value={name}
                                    onChange={onChangeName}
                                />
                                <AppPhoneInput
                                    id="Telefone_id"
                                    value={telephone}
                                    onChange={onChangeTelephone}
                                    placeholder="Telefone"
                                    defaultCountry="BR"
                                    width_max={70}
                                    inputHeight={56}
                                    limitMaxLength={true}
                                    inputClassName={styles.input}
                                    semPais={!site?.internacional ? true : false}
                                    includeCountryCode={site?.internacional ? true : false} 
                                />
                                <input
                                    className={styles.input}
                                    placeholder="Email"
                                    value={email}
                                    onChange={onChangeEmail}
                                />
                                {detailsProperties.aluguel && detailsProperties.venda ?
                                    <>
                                        <label className={styles.title_form_one1}>
                                            SELECIONE SEU INTERESSE:
                                        </label>
                                        <ButtonGroup disableElevation variant="contained" color="primary" style={{marginBottom: "15px"}}>
                                            <Button onClick={selectTransacao} style={interesse == "Venda" ? site?.cor2 == "#ffffff" ? { backgroundColor: "gray", border: "1px solid gray"} : { backgroundColor: site?.cor2, border: "1px solid gray"} : { backgroundColor: "white", color: "#3d3d3d", border: "1px solid #3d3d3d" }}>Venda</Button>
                                            <Button onClick={selectTransacao} style={interesse == "Aluguel" ? site?.cor2 == "#ffffff" ? { backgroundColor: "gray", border: "1px solid gray"} : { backgroundColor: site?.cor2, border: "1px solid gray"} : { backgroundColor: "white", color: "#3d3d3d", border: "1px solid #3d3d3d" }}>Aluguel</Button>
                                        </ButtonGroup>
                                    </>
                                : null}
                                <div className={styles.adjust_checkbox}>
                                <Checkbox
                                    style={{ color: 'rgb(126, 126, 126)' }}
                                    checked={acceptPolitic}
                                    onChange={(event, value) => setAcceptPolitic(value)}
                                />
                                <div className={styles.description_form}>
                                    Ao enviar concordo com os
                                    <Link prefetch={false} href="/termos">
                                        <label className={styles.terms}>
                                            termos de uso
                                        </label>
                                    </Link>
                                    e
                                    <Link prefetch={false} href="/politica">
                                        <label className={styles.terms}>
                                            política de privacidade,
                                        </label>
                                    </Link>
                                    para contatar os próximos anunciantes e afirmo ter mais
                                    de 18 anos
                                </div>
                            </div>
                                <a
                                    className={
                                        acceptPolitic && name != '' && email != '' && !processando && telephone != '' && telephone.length > 10 && telephone.length < 16 && /\S+@\S+\.\S+/.test(email) == true
                                            ? styles.button_more_photo
                                            : styles.action_more_disabled
                                    }
                                    onClick={validaSendUser}
                                >
                                {detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ? site?.id == 1630 ? 'Acessar Agora' : 'Ver fotos e vídeo' : site?.id == 1630 ? 'Acessar Agora' : 'Ver fotos'}
                                </a>
                            </div>
                            {/* ) : (
                                <label className={styles.welcome}>
                                    Carregar + fotos
                                </label>
                            )} */}
                        </div>
                    );
                }

                if ((v?.id === 'video' && detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059')) && (existUser ||
                    verFts == "1" || verfts == '1' || (!site?.bloquear_fotos && (!detailsProperties?.bloquear_fotos == true)) || orderGallery?.length < site?.qtd_fotos_bloqueios)) {
                    const getFirstPhoto = orderGallery?.find(
                        (e: any) => e?.url_foto
                    );
                    return (
                        <div
                            onClick={openPhoto}
                            key={'galeria'+v?.id}
                            className={styles.container_img}
                        >
                            <WatermarkFallbackImage
                                src={getWatermarkImageSrc(getFirstPhoto?.url_foto, site)}
                                retrySrc={getWatermarkImageSrc(getFirstPhoto?.url_foto_menor, site)}
                                fallbackSrc={getFirstPhoto?.url_foto}
                                alt={`Vídeo do imóvel${hasPropertyTitle ? ` ${propertyTitle}` : ''}`}
                                className={styles.img}
                                fill
                                sizes="(max-width: 768px) 100vw, 50vw"
                                unoptimized
                            />
                            <div className={styles.background_animation1}>
                                <FaPlay size={100} color="white" />
                            </div>
                        </div>
                    );
                } else {
                    if(v?.id === 'tour360'){
                        return (
                            <div
                                onClick={openPhoto}
                                key={'tour'+v?.id}
                                className={styles.container_img}
                            >
                                <iframe className={styles.img} id="tour-360" src={v?.video}></iframe>
                                <div className={styles.background_animation1}>
                                    <Md360 size={100} color="white" />
                                </div>
                            </div>
                        );
                    }
                }
                return v?.url_foto ? (
                    <div
                        onMouseEnter={activeAnimationPhoto}
                        onClick={openPhoto}
                        key={'close'+v?.id}
                        className={styles.container_img}
                    >
                        <WatermarkFallbackImage
                            src={photoSrc}
                            retrySrc={photoRetrySrc}
                            fallbackSrc={v?.url_foto}
                            className={styles.img}
                            alt={`Foto do imóvel${hasPropertyTitle ? ` ${propertyTitle}` : ''}`}
                            fill
                            sizes="(max-width: 768px) 100vw, 50vw"
                            {...(isPriorityPhoto ? { priority: true } : {})}
                            unoptimized
                        />
                        {animationPhoto === Number(v?.id) ? (
                            <div className={styles.background_animation}>+</div>
                        ) : null}
                    </div>
                ) : null;
            })}
        </div>
    );
};

export default GalleryPiecesProperties;

export const getServerSideProps = async () => ({ notFound: true });
